module.exports = __webpack_public_path__ + "img/UTFREM-16.30c34df1.jpg";